import { safeJsonParse } from '../../helper/utils/safeJsonParse.js';
import actions from './waiver.types.js';

const waiver = safeJsonParse(localStorage.getItem('waiver'), {});
const isVerifiedWaiver = (localStorage.getItem('isVerifiedWaiver') || 'false') === 'true';

const initialState = {
    loading: false,
    loadingWaiver: false,
    loadingRegister: false,
    loadingSendOTP: false,
    loadingVerifyOTP: false,
    loadingSignIn: false,
    errMsg: '',

    minor: waiver['children'] || [],
    isVerifiedWaiver,
    waiver: waiver['data'] || {},
    orderDetail: {},
};

export default function waiverReducer(state = initialState, action) {
    switch (action.type) {
        case actions.SET_STATE:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
